<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
// Overrides @basecom-gmbh/pond/components/Layout/LayoutSidebar.vue
const props = withDefaults(
    defineProps<{
        controller: ReturnType<typeof useModal>;
        isClosable?: boolean;
        side?: 'left' | 'right' | 'bottom';
        isScrollable?: boolean;
        closeButton?: string;
    }>(),
    {
        side: 'left',
        isClosable: true,
        isScrollable: true,
        closeButton: 'h-8 w-8',
    },
);

const { controller } = toRefs(props);
const { isOpen, close } = controller.value;

const sidebarContentElement = ref();
onClickOutside(sidebarContentElement, () => (props.isClosable ? close() : ''));
</script>

<template>
    <!-- IDS-36 - Change sidebar styles-->
    <Teleport to="body">
        
<FormKitLazyProvider config-file="true">
<div
            ref="sidebarContentElement"
            class="bg-white fixed z-40 flex flex-col transition-transform duration-500"
            tabindex="-1"
            aria-labelledby="sidebar"
            :class="{
                '!translate-x-0': isOpen && (side === 'left' || side === 'right'),
                'top-0 h-dvh w-10/12 sm:w-96': side === 'left' || side === 'right',
                '!translate-y-0': isOpen && side === 'bottom',
                'bottom-0 h-[90dvh] w-full': side === 'bottom',
                'left-0 -translate-x-full': side === 'left',
                'right-0 translate-x-full': side === 'right',
                'bottom-0 translate-y-full': side === 'bottom',
                'overflow-y-auto': isScrollable,
            }"
        >
            <!-- IDS-188: change style -->
            <div class="flex items-center justify-between px-6 py-8">
                <slot name="header" />

                <!-- IDS-188: change icon, change size -->
                <FormKitIcon
                    icon="x"
                    class="block cursor-pointer"
                    :class="closeButton"
                    @click="controller.close()"
                />
            </div>
            <div class="max-h-full flex-grow overflow-y-scroll">
                <slot name="content" />
            </div>
            <slot name="footer" />
        </div>

        <!-- body overlay -->
        <div
            v-if="isOpen"
            class="fixed inset-0 z-30 h-screen w-screen bg-neutral-800/70"
        />
</FormKitLazyProvider>

    </Teleport>
</template>
